import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import defaultStyles from './RecalculateData.module.scss';

const RecalculateData = props => (
    <button
        className={ props.styles.recalculateHeader }
        type="button"
        onClick={ props.recalculatePageData }
    >
        Recalculate Data
    </button>
);

RecalculateData.propTypes = {
    recalculatePageData: PropTypes.func,
    styles: PropTypes.objectOf(PropTypes.string)
};

RecalculateData.defaultProps = {
    recalculatePageData: noop,
    styles: defaultStyles
};

export default RecalculateData;
